import { useState, useEffect } from 'react';
import axios from 'axios';
import { Table } from '../TradeCurrency/Table';
import { MdAccountCircle } from 'react-icons/md';
import { formatDateStrToDate, getToken } from '../utils';
import { LoadingMode } from '../Components/LoadingMode';
import NoPenalties from '../Components/NoPenalties';

function TransactionPenaltyTable() {
  const [penalties, setPenalties] = useState([]);
  const [loading, setLoading] = useState(true); // Add loading state

  const { token: userToken } = getToken();
  const userId = getToken()?.user?.id;

  const tableHeader = [
    {
      accessor: 'user',
      transactionID: 'transactionId',
      penaltyAmount: 'user',
      status: 'status',
      date: 'date',
    },
  ];

  useEffect(() => {
    const fetchAllReferes = async () => {
      const url = `${process.env.REACT_APP_BASE_URL}/penalty/history`;

      try {
        const response = await axios.get(url, {
          headers: { Authorization: `Bearer ${userToken}` },
        });
        setPenalties(response.data);
        console.log('user penalty:', response.data);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false); // Set loading to false once the data is fetched
      }
    };
    fetchAllReferes();
  }, [userId, userToken]);

  const penaltiesArray = penalties?.map((penalty) => ({
    user: (
      <div className='flex flex-col gap-2 max-w-sm items-start'>
        <div className='flex flex-row gap-2 w-full justify-between'>
          <div className='flex flex-row gap-3 items-start w-full'>
            <MdAccountCircle className='text-xl -mt-1 text-b-mc/70 ' />
            <div className='flex flex-col w-full text-left'>
              <p className='text-xs -mt-1 text-b-mc/70 '>{penalty?.cx_transaction?.unique_code}</p>
            </div>
          </div>
          <p className='text-xs w-full'>{Number(penalty?.amount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}{penalty?.currency?.symbol} </p>
          <p className='text-xs text-s-bk w-full'>
            {penalty?.penalty_status?.name}
          </p>
          <p className='text-xs text-s-bk w-full'>
            {formatDateStrToDate(penalty?.created_at)}
          </p>
        </div>
      </div>
    ),
    transactionId: (
      <div className='flex flex-col gap-2 max-w-sm items-start'>
        <div className='flex flex-row gap-2 w-full justify-between'>
          <div className='flex flex-row gap-3 items-start w-full'>
            <MdAccountCircle className='text-xl -mt-1 text-b-mc/70 ' />
            <div className='flex flex-col w-full text-left'>
              <p className='text-xl -mt-1 text-b-mc/70 '>{penalty?.cx_transaction?.unique_code}</p>
            </div>
          </div>
          <p className='text-xl w-full'>{penalty?.amount}{penalty?.currency?.symbol} </p>
          <p className='text-xl text-s-bk w-full'>
            {penalty?.penalty_status?.name}
          </p>
          <p className='text-xl text-s-bk w-full'>
            {formatDateStrToDate(penalty?.created_at)}
          </p>
        </div>
      </div>
    ),
    status: (
      <div className='flex flex-col gap-2 max-w-sm items-start'>
        <div className='flex flex-row gap-2 w-full justify-between'>
          <div className='flex flex-row gap-3 items-start w-full'>
            <MdAccountCircle className='text-xl -mt-1 text-b-mc/70 ' />
            <div className='flex flex-col w-full text-left'>
              <p className='text-xl -mt-1 text-b-mc/70 '>{penalty?.cx_transaction?.unique_code}</p>
            </div>
          </div>
          <p className='text-xl w-full'>{penalty?.amount}{penalty?.currency?.symbol} </p>
          <p className='text-xl text-s-bk w-full'>
            {penalty?.penalty_status?.name}
          </p>
          <p className='text-xl text-s-bk w-full'>
            {formatDateStrToDate(penalty?.created_at)}
          </p>
        </div>
      </div>
    ),
    date: (
      <div className='flex flex-col gap-2 max-w-sm items-start'>
        <div className='flex flex-row gap-2 w-full justify-between'>
          <div className='flex flex-row gap-3 items-start w-full'>
            <MdAccountCircle className='-mt-1 text-b-mc/70 ' />
            <div className='flex flex-col w-full text-left'>
              <p className='text-xs -mt-1 text-b-mc/70 '>{penalty?.cx_transaction?.unique_code}</p>
            </div>
          </div>
          <p className='text-xs w-full'>{Number(penalty?.amount * 1).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} {penalty?.currency?.symbol} </p>
          <p className='text-s-bk w-full'>
            {penalty?.penalty_status?.name}
          </p>
          <p className='text-s-bk w-full'>
            {formatDateStrToDate(penalty?.created_at)}
          </p>
        </div>
      </div>
    ),
    
  }));

  if (loading) {
    return <LoadingMode />;
  }

  return (
    <article className='mx-6'>
      {penaltiesArray.length === 0 ? (
        <NoPenalties /> // Use the NoPenalties component when no data is available
      ) : (
        <Table columns={tableHeader} data={penaltiesArray} />
      )}
    </article>
  );
}

export default TransactionPenaltyTable;
